import { types } from './action'

export default (state = [], action) => {
  switch (action.type) {
    case types.GET_LANDINGS:
      return action.payload
    case types.ADD_NEW_LANDING:
      return [
        ...state,
        action.payload
      ]
    default:
      return state;
  }
};
